// ==========================================================================
// AngelKissBag 整合优化主题 JS（极速启动与执行效率完美版 - 全局封装版）
// ==========================================================================

(function() {
    // 提前提取高频重用变量，压榨内存与作用域链查找性能
    const doc = document;
    const win = window;
    const customerData = win.ShopifyCustomer || { id: "", email: null };

    // --- 辅助工具函数 ---
    function toTitleCase(str) {
        return str.toLowerCase().replace(/(?:^|\s)\S/g, m => m.toUpperCase());
    }

    // 智能搜索跳转与重定向 (不等待全页 DOM 加载，利用高效率委托机制)
    function initSmartSearch() {
        doc.addEventListener('submit', async function(event) {
            const form = event.target.closest('.luxury-search-form, form[action="/search"]');
            if (!form) return;

            const input = form.querySelector('input[name="q"]');
            if (!input) return;

            event.preventDefault(); 
            const query = input.value.trim().toLowerCase();
            if (!query) return;

            const quickRedirects = { 'bags': '/collections/all', 'all': '/collections/all' };
            if (quickRedirects[query]) {
                win.location.href = quickRedirects[query];
                return;
            }

            try {
                const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection`);
                const data = await response.json();
                const collections = data.resources?.results?.collections; 

                if (collections && collections.length > 0) {
                    const queryWordsSorted = query.split(/\s+/).filter(w => w).sort().join(' ');
                    const exactMatch = collections.find(c => {
                        const titleWordsSorted = c.title.toLowerCase().split(/\s+/).filter(w => w).sort().join(' ');
                        const handleWordsSorted = c.handle.toLowerCase().replace(/-/g, ' ').split(/\s+/).filter(w => w).sort().join(' ');
                        return queryWordsSorted === titleWordsSorted || queryWordsSorted === handleWordsSorted;
                    });

                    if (exactMatch) {
                        win.location.href = exactMatch.url.split('?')[0];
                        return;
                    }
                }
                win.location.href = `/search?q=${encodeURIComponent(query)}`;
            } catch (error) {
                console.error("Search redirect error:", error);
                win.location.href = `/search?q=${encodeURIComponent(query)}`;
            }
        });
    }

    // 大写转首字母大写功能（性能优化版）
    function initTitleCase() {
        const labelSelectors = ['a', '.navtext', '.radio__legend__label', '.product-form__label', 'legend'];
        doc.querySelectorAll(labelSelectors.join(', ')).forEach(el => {
            if (el.textContent && el.children.length === 0) {
                el.textContent = toTitleCase(el.textContent.trim()) + ' '; 
            }
        });

        // 动态变更的标签采用更轻量化的防死循环处理
        doc.querySelectorAll('[data-option-value], [data-selected-value]').forEach(el => {
            if (el.textContent) el.textContent = toTitleCase(el.textContent.trim());

            const observer = new MutationObserver(mutations => {
                let shouldUpdate = false;
                for (let i = 0; i < mutations.length; i++) {
                    if (mutations[i].type === 'childList' || mutations[i].type === 'characterData') {
                        shouldUpdate = true;
                        break;
                    }
                }
                if (shouldUpdate) {
                    observer.disconnect();
                    el.textContent = toTitleCase(el.textContent.trim());
                    observer.observe(el, { childList: true, characterData: true, subtree: true });
                }
            });
            observer.observe(el, { childList: true, characterData: true, subtree: true });
        });
    }

    // ==========================================
    // 【核心封装】提取为全局独立的底层函数
    // ==========================================
    function globalInitVariantWraps() {
        document.querySelectorAll('.variant-wrap').forEach(wrap => {
            const container = wrap.querySelector('.variant-tabs');
            const leftBtn = wrap.querySelector('.variant-arrow-left');
            const rightBtn = wrap.querySelector('.variant-arrow-right');
            if (!container || !leftBtn || !rightBtn) return;

            // 【核心修改点1】定义你想要拉开的空白间距
            const tabGap = 12; 

            const adjustTabsAlignment = () => {
                const tabs = container.querySelectorAll('.variant-tab');
                const tabCount = tabs.length;
                if (!tabCount) return;

                // 【核心修改点2】动态应用间距，最后一项外边距留空清零
                tabs.forEach((tab, i) => {
                    tab.style.marginRight = (i < tabCount - 1) ? `${tabGap}px` : '0px';
                });

                const isMobile = window.innerWidth <= 768;
                // 【核心修改点3】手机端限制 3 个，电脑端 5 个
                const limit = isMobile ? 3 : 5; 

                if (tabCount <= limit) {
                    container.style.justifyContent = "center";
                    leftBtn.style.display = rightBtn.style.display = "none";
                    container.style.width = "";
                } else {
                    container.style.justifyContent = "flex-start";
                    leftBtn.style.display = rightBtn.style.display = "";
                    
                    let totalWidth = 0;
                    for (let i = 0; i < limit; i++) {
                        if (tabs[i]) totalWidth += tabs[i].offsetWidth;
                    }
                    // 【核心修改点4】精确将拉开的外间距叠加至强截宽度中
                    totalWidth += (limit - 1) * tabGap; 
                    container.style.width = totalWidth + "px";
                }
            };

            const updateArrows = () => {
                leftBtn.style.opacity = container.scrollLeft > 5 ? '1' : '0';
                rightBtn.style.opacity = container.scrollLeft < (container.scrollWidth - container.clientWidth - 5) ? '1' : '0';
            };

            // 【核心修改点5】翻页动作精确适配当前视图的宽度与间距
            leftBtn.onclick = () => {
                const tabs = container.querySelectorAll('.variant-tab');
                if (!tabs.length) return;
                const isMobile = window.innerWidth <= 768;
                const scrollCount = isMobile ? 3 : 4;
                
                let scrollDistance = 0;
                for(let i = 0; i < scrollCount; i++) {
                    if(tabs[i]) scrollDistance += tabs[i].offsetWidth + tabGap;
                }
                container.scrollBy({ left: -1 * scrollDistance, behavior: 'smooth' });
            };
            
            rightBtn.onclick = () => {
                const tabs = container.querySelectorAll('.variant-tab');
                if (!tabs.length) return;
                const isMobile = window.innerWidth <= 768;
                const scrollCount = isMobile ? 3 : 4;
                
                let scrollDistance = 0;
                for(let i = 0; i < scrollCount; i++) {
                    if(tabs[i]) scrollDistance += tabs[i].offsetWidth + tabGap;
                }
                container.scrollBy({ left: scrollDistance, behavior: 'smooth' });
            };

            container.onscroll = updateArrows;

            let isDown = false, startX, scrollLeft;
            container.onmousedown = e => {
                isDown = true;
                startX = e.pageX - container.offsetLeft;
                scrollLeft = container.scrollLeft;
                container.style.cursor = "grabbing";
            };
            const stopDrag = () => { isDown = false; container.style.cursor = "grab"; };
            container.onmouseleave = stopDrag;
            container.onmouseup = stopDrag;
            container.onmousemove = e => {
                if (!isDown) return;
                e.preventDefault();
                container.scrollLeft = scrollLeft - ((e.pageX - container.offsetLeft) - startX);
                updateArrows();
            };

            adjustTabsAlignment();
            updateArrows();
        });
    }

    // 挂载到全局 API 对象上，方便其他页面随时随地调用
    win.AngelKissGlobal = {
        initVariantWraps: globalInitVariantWraps
    };

    // --- 核心全局应用对象 ---
    const AngelKissApp = {
        currentUser: {
            id: customerData.id,
            email: customerData.email,
            isLoggedIn: customerData.id !== ""
        },
        scrollTicking: false,
        mutationTimeout: null,

        init() {
            this.cacheDOM();
            this.bindGlobalEvents();
            this.initFunctionalModules();
            this.setupMutationObserver();
            this.updateWishlistStatus();
            
            if (this.currentUser.isLoggedIn) this.autoMergeWishlistIfNeeded();
            this.initFirstScreenVariantMatch();
        },

        cacheDOM() {
            this.popUp = doc.querySelector('.pop-up-window');
            this.popUpSpan = this.popUp?.querySelector('span');
            this.scrollToTopBtn = doc.querySelector('.toTop');
        },

        showPopUp(message) {
            if (!this.popUp || !this.popUpSpan) return;
            this.popUp.classList.add('show');
            this.popUpSpan.textContent = message;
            setTimeout(() => {
                this.popUp.classList.remove('show');
                this.popUpSpan.textContent = '';
            }, 1500);
        },

        handleVariantChange(btn) {
                        if (!btn) return;

                        const item = btn.closest('.product-grid-item, .product__info-wrapper');
                            // console.log('当前点击的 item 容器:', item);
                        if (!item) return;

                        const data = btn.dataset;
                        const mainImg = item.querySelector('[data-main-image], .main-image');
                        const mainTitle = item.querySelector('[data-main-title], .main-title');
                        const mainLinkEl = item.querySelector('[data-main-link], .main-link');
                        const wishlistBtn = item.querySelector('.wishlist-btn');
                        const addToCartBox = item.querySelector('.add-to-cart-box');
                        const PreOrderA = item.querySelector('.Pre-Order-A');
                        
                        // const vTitle = (data.variantTitle || '').trim().toLowerCase().replace(/(?:^|\s)\S/g, m => m.toUpperCase());
                        // const targetUrl = data.variantUrl || (mainLinkEl ? mainLinkEl.href : '');
                        // const pTitle = item.dataset.productTitle || (mainTitle?.textContent.split(' / ')[1] || mainTitle?.textContent || '');


                        // Variant 原始标题
                        const vTitle = (data.variantTitle || '').trim();
                        const vColor = vTitle.toLowerCase().replace(/(?:^|\s|\/)\S/g, m => m.toUpperCase());
                        const targetUrl = data.variantUrl || (mainLinkEl ? mainLinkEl.href : '');
                        // 原始产品标题
                        const pTitle = item.dataset.productTitle || mainTitle?.textContent || '';


                        if (data.variantImage && mainImg) {
                            mainImg.src = data.variantImage;
                            if (mainImg.hasAttribute('srcset')) mainImg.removeAttribute('srcset');
                        }

                        if (targetUrl) {
                            const links = item.querySelectorAll('[data-main-link], .main-link, [data-main-title], .main-title');
                            for(let i=0; i<links.length; i++) { if(links[i]) links[i].href = targetUrl; }
                        }

                        // if (vTitle && mainTitle) {
                        //     mainTitle.textContent = vTitle.includes('/') ? vTitle : `${vTitle} / ${pTitle}`;
                        // }

                        if (mainTitle) {
                            mainTitle.textContent = pTitle;
                        }

                        // ================================
                        // 更新当前选中的颜色
                        // ================================
                    
                        const colorName = item.querySelector('.product-color-name .product-color-value');

                        if (colorName && vColor) {
                            colorName.textContent = vColor;
                            //colorName.innerHTML = vColor;
                        }

                        const vIdInput = item.querySelector('#variant-id');
                        const vImgInput = item.querySelector('#variant-image');
                        const vTitleInput = item.querySelector('#variant-title');
                        if (vIdInput && data.variantId) vIdInput.value = data.variantId;
                        if (vImgInput && data.variantImage) vImgInput.value = data.variantImage;
                        if (vTitleInput && vTitle) vTitleInput.value = vTitle;

                        if (wishlistBtn) {
                            if (data.variantId) wishlistBtn.setAttribute('data-variant-id', data.variantId);
                            if (vTitle) wishlistBtn.setAttribute('data-variant-title', vTitle);
                            if (data.variantImage) {
                                wishlistBtn.setAttribute('data-variant-image', data.variantImage);
                                wishlistBtn.setAttribute('data-product-image', data.variantImage);
                            }
                            if (targetUrl) wishlistBtn.setAttribute('data-product-url', targetUrl);
                            if (mainTitle) wishlistBtn.setAttribute('data-product-title', mainTitle.textContent);
                        }

                        if (btn.classList.contains('No-stock')) {
                            if (wishlistBtn) wishlistBtn.style.display = 'none';
                            if (addToCartBox) addToCartBox.style.display = 'none';
                            if (PreOrderA) {
                                PreOrderA.style.display = 'block';
                                PreOrderA.href = targetUrl;
                            }
                        } else {
                            if (wishlistBtn) wishlistBtn.style.display = 'block';
                            if (addToCartBox) addToCartBox.style.display = '';
                            if (PreOrderA) PreOrderA.style.display = 'none';
                        }

                        const tabs = item.querySelectorAll('.variant-tab');
                        for(let i=0; i<tabs.length; i++) { tabs[i].classList.remove('on', 'is-active'); }
                        btn.classList.add('on', 'is-active');
                        
                        this.scrollToActiveTab(btn);
        },

        scrollToActiveTab(btn) {
            const container = btn.closest('.variant-tabs');
            if (container) {
                const offset = btn.offsetLeft - (container.clientWidth / 2) + (btn.clientWidth / 2);
                container.scrollBy({ left: offset - container.scrollLeft, behavior: 'smooth' });
            }
        },

        initVariantWraps() {
            // 当前页面调用刚刚挂载的全局底层函数
            globalInitVariantWraps();
        },

        triggerVariantRebind(delay = 300) { 
            clearTimeout(this.rebindTimeout);
            this.rebindTimeout = setTimeout(() => { this.initVariantWraps(); }, delay);
        },

        async getWishlistToken() {
            if (this.currentUser.isLoggedIn) return null;
            let token = localStorage.getItem("wishlist_token");
            if (token) return token;

            try {
                const res = await fetch("https://akapi.angelkiss.cn/USwishlist/create", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ userId: "guest", email: null })
                });
                const data = await res.json();
                localStorage.setItem("wishlist_token", data.token);
                return data.token;
            } catch (e) { console.warn("Create token failed", e); return null; }
        },

        async autoMergeWishlistIfNeeded() {
            if (!this.currentUser.isLoggedIn) return;
            const token = localStorage.getItem("wishlist_token");
            if (!token) return;

            const mergedKey = "wishlist_merged_" + this.currentUser.email;
            if (localStorage.getItem(mergedKey) === "1") return;

            try {
                const res = await fetch("https://akapi.angelkiss.cn/USwishlist/merge", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email: this.currentUser.email, userId: this.currentUser.id, token })
                });
                const data = await res.json();
                if (data.success && data.merged) {
                    localStorage.setItem(mergedKey, "1");
                    localStorage.removeItem("wishlist_token");
                    await this.updateWishlistStatus();
                }
            } catch (e) { console.warn("Wishlist merge failed", e); }
        },

        async updateWishlistStatus() {
            let url = this.currentUser.isLoggedIn 
                ? `https://akapi.angelkiss.cn/USwishlist/${encodeURIComponent(this.currentUser.email)}`
                : (localStorage.getItem("wishlist_token") ? `https://akapi.angelkiss.cn/USwishlist/${localStorage.getItem("wishlist_token")}` : null);

            if (!url) return;
            try {
                const res = await fetch(url);
                const data = await res.json();
                const count = data?.items?.length || 0;

                doc.querySelectorAll('.hd-wishlist-btn').forEach(btn => {
                    const countEl = btn.querySelector('.wishlist-count');
                    const sc = btn.querySelector('.sc');
                    const sced = btn.querySelector('.sced');

                    if (countEl) {
                        countEl.textContent = count || "";
                        countEl.style.display = count ? "inline" : "none";
                    }
                    if (sc) sc.style.display = count ? "none" : "flex";
                    if (sced) sced.style.display = count ? "flex" : "none";
                });
            } catch (e) { console.warn("Update Wishlist Status failed", e); }
        },

        initFirstScreenVariantMatch() {
            doc.querySelectorAll('product-grid-item').forEach(card => {
                const mainImg = card.querySelector('.main-image');
                if (!mainImg) return;
                const mainSrc = mainImg.src.split('?')[0];
                const tabs = card.querySelectorAll('.variant-tab');
                
                for (let i = 0; i < tabs.length; i++) {
                    const tabImg = tabs[i].querySelector('img');
                    if (tabImg && tabImg.src.split('?')[0] === mainSrc) {
                        this.handleVariantChange(tabs[i]);
                        break;
                    }
                }
            });
        },

        bindGlobalEvents() {
            doc.addEventListener('click', async (e) => {
                const target = e.target;

                const variantTab = target.closest('.variant-tab');
                if (variantTab) {
                    this.handleVariantChange(variantTab);
                    return;
                }

                const wishBtn = target.closest('.wishlist-btn');
                if (wishBtn) {
                    e.preventDefault();
                    const token = await this.getWishlistToken();
                    const wished = wishBtn.dataset.wished === "1";
                    const apiPath = wished ? "/USwishlist/remove" : "/USwishlist/add";

                    const payload = {
                        wishlistToken: token,
                        productId: wishBtn.dataset.productId,
                        productTitle: wishBtn.dataset.productTitle,
                        productImage: wishBtn.dataset.productImage,
                        productUrl: wishBtn.dataset.productUrl,
                        variantId: wishBtn.dataset.variantId,
                        variantTitle: wishBtn.dataset.variantTitle,
                        productPrice: wishBtn.dataset.productPrice,
                        productCompareAtPrice: wishBtn.dataset.productCompareAtPrice || null,
                        userId: this.currentUser.id || null,
                        email: this.currentUser.email || null
                    };

                    try {
                        const bodyData = wished 
                            ? { wishlistToken: token || null, productId: payload.productId, variantId: payload.variantId, email: this.currentUser.email || null, userId: this.currentUser.id || null }
                            : payload;

                        await fetch(`https://akapi.angelkiss.cn${apiPath}`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(bodyData)
                        });

                        const sc = wishBtn.querySelector('.sc');
                        const sced = wishBtn.querySelector('.sced');

                        if (wished) {
                            wishBtn.dataset.wished = "0";
                            if (sc) sc.style.display = 'flex';
                            if (sced) sced.style.display = 'none';
                            this.showPopUp('Wish removed');
                        } else {
                            wishBtn.dataset.wished = "1";
                            if (sc) sc.style.display = 'none';
                            if (sced) sced.style.display = 'flex';
                            this.showPopUp('Added to wish list');
                        }
                        this.updateWishlistStatus();
                    } catch(err) { console.warn("Wishlist action failed", err); }
                    return;
                }

                const hdWishBtn = target.closest('.hd-wishlist-btn');
                if (hdWishBtn) {
                    e.preventDefault();
                    const token = await this.getWishlistToken();
                    let wishlistUrl = token 
                        ? `/collections/wishlist?token=${encodeURIComponent(token)}`
                        : (this.currentUser.email ? `/collections/wishlist?email=${encodeURIComponent(this.currentUser.email)}` : '');

                    if (wishlistUrl) win.location.href = wishlistUrl;
                    else alert('Please login to view your wishlist.');
                    return;
                }

                if (target.closest('.sidebar__navigation__list__item, .active__filters__remove')) {
                    this.triggerVariantRebind();
                }
            });

            doc.addEventListener('submit', (e) => {
                const form = e.target.closest('.add-to-cart-form');
                if (!form) return;

                e.preventDefault();
                const gridItem = form.closest('.product-grid-item');
                if (!gridItem) return;

                const activeVariant = gridItem.querySelector('.variant-tab.on');
                if (activeVariant && activeVariant.classList.contains('No-stock')) {
                    this.showPopUp('This style is currently out of stock.');
                    return;
                }

                this.showPopUp('Added to cart');

                fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
                    .then(res => res.json())
                    .catch(err => console.error("Error adding product to cart:", err));
            });

            if (this.scrollToTopBtn) {
                win.addEventListener('scroll', () => {
                    if (!this.scrollTicking) {
                        win.requestAnimationFrame(() => {
                            const scrollTop = doc.documentElement.scrollTop || doc.body.scrollTop;
                            this.scrollToTopBtn.style.display = scrollTop > 300 ? 'block' : 'none';
                            this.scrollTicking = false;
                        });
                        this.scrollTicking = true;
                    }
                }, { passive: true });

                this.scrollToTopBtn.addEventListener('click', () => {
                    win.scrollTo({ top: 0, behavior: 'smooth' });
                });
            }

            win.addEventListener('load', () => this.triggerVariantRebind(100), { passive: true });
            win.addEventListener('resize', () => this.triggerVariantRebind(100), { passive: true });

            this.initAutoCarousel();
        },
        
        initAutoCarousel() {
            doc.querySelectorAll("product-grid-item").forEach(item => {
                const imgBox = item.querySelector(".main-image-box");
                const tabs = item.querySelectorAll(".variant-tab");
                if (!imgBox || tabs.length === 0) return;

                let intervalId = null, timerId = null;
                imgBox.addEventListener("mouseenter", () => {
                    if (timerId) clearTimeout(timerId);
                    if (intervalId) clearInterval(intervalId);
                    timerId = setTimeout(() => {
                        intervalId = setInterval(() => {
                            const arr = Array.from(tabs);
                            const current = arr.findIndex(t => t.classList.contains("on"));
                            const next = ((current >= 0 ? current : 0) + 1) % arr.length;
                            this.handleVariantChange(arr[next]);
                        }, 1500);
                    }, 1500);
                }, { passive: true });

                imgBox.addEventListener("mouseleave", () => {
                    if (timerId) clearTimeout(timerId);
                    if (intervalId) clearInterval(intervalId);
                }, { passive: true });
            });
        },

        setupMutationObserver() {
            const observer = new MutationObserver(() => {
                clearTimeout(this.mutationTimeout);
                this.mutationTimeout = setTimeout(() => {

                    doc.querySelectorAll('.main-image-box').forEach(box => {
                        const link = box.querySelector('a[href*="/products/packaging"]');
                        const btn = box.querySelector('.wishlist-btn');
                        if (link && btn && btn.style.display !== 'none') {
                            btn.style.display = 'none';
                            btn.innerHTML = '';
                        }
                    });
                    
                    doc.querySelectorAll('input.filter__price__input:not([data-bind-variant])').forEach(input => {
                        input.dataset.bindVariant = "true";
                        input.addEventListener('blur', () => this.triggerVariantRebind());
                        input.addEventListener('keydown', (e) => { if (e.key === 'Enter') this.triggerVariantRebind(); });
                    });

                }, 80);
            });
            observer.observe(doc.body, { childList: true, subtree: true });
        },

        initFunctionalModules() {
            this.initVariantWraps();
            
            doc.querySelectorAll(".product__rating__value").forEach(el => {
                let raw = parseFloat(el.textContent.trim());
                if (!isNaN(raw)) el.textContent = raw.toFixed(1);
            });

            const waLink = doc.querySelector('.footer__socials a:nth-child(5)');
            if (waLink) {
                waLink.setAttribute('title', 'WhatsApp');
                waLink.setAttribute('aria-label', 'WhatsApp');
                waLink.setAttribute('data-channel', 'WhatsApp');
                waLink.querySelector('img')?.setAttribute('alt', 'WhatsApp');
            }
        }
    };

    // --- 极速同步核心启动逻辑 ---
    initSmartSearch();
    if (doc.readyState !== "loading") {
        initTitleCase();
        AngelKissApp.init();
    } else {
        doc.addEventListener("DOMContentLoaded", () => {
            initTitleCase();
            AngelKissApp.init();
        });
    }
})();